<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">

          <h3 class="mb-0">{{$t('last_checkin')}}</h3>

        <div class="col text-right">
          <!-- <a href="#!" class="btn btn-sm btn-primary">See all</a> -->
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light"
                  :data="tableData">
        <template slot="columns">
          <th>{{$t('first_name')}} {{$t('last_name')}}</th>
          <th>{{$t('nickname')}}</th>
          <th>{{$t('checkin')}}</th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <router-link class="dashboard-link" :to="'/'+$i18n.locale+'/edit_member?id='+row._id">
              {{row.name}}
            </router-link>
          </th>
          <td>
            <router-link class="dashboard-link" :to="'/'+$i18n.locale+'/edit_member?id='+row._id">
              {{row.nickname}}
            </router-link>
          </td>
          <td>
            <router-link class="dashboard-link" :to="'/'+$i18n.locale+'/edit_member?id='+row._id">
              {{row.check_in_at | luxon}}
            </router-link>
          </td>
        </template>

      </base-table>
    </div>

    <modal :show.sync="modal"
               :gradient="modal_setting.gradient"
               modal-classes="modal-danger modal-dialog-centered">
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4"></h4>
                <p>{{modal_setting.alert_text}}</p>
            </div>

            <template slot="footer">
                <base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="modal = false">
                    {{$t('close')}}
                </base-button>
            </template>
        </modal>

  </div>
</template>
<script>
  export default {
    name: 'visits-table',
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        tableData: [
        ]
      }
    },
    created () {
        this.ListItem2()
    },
    methods: {
        modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        ListItem2 () {
            this.$http.get('dashboard/members?limit=5')
            .then(request => this.ListItem2Successful(request))
            .catch(() => this.ListItem2Failed())
        },
        ListItem2Successful (req) {
            if (req.data.code !== '0') {
                this.ListItem2Failed(req)
                return
            }
            for (let i = 0; i < req.data.data.recents.length; i++) {
                this.tableData.push(
                  {
                    'name':req.data.data.recents[i].member.firstname+' '+req.data.data.recents[i].member.lastname,
                    'nickname':req.data.data.recents[i].member.nickname,
                    '_id':req.data.data.recents[i].member._id,
                    'check_in_at':req.data.data.recents[i].check_in_at
                  }
                )
            }
        },
        ListItem2Failed (req) {
            this.modalAlert(req)
        }
    }
  }
</script>
<style>
</style>
